import { DegreeLevelLabel, RadioSelect } from '@uc/web/shared/data-models';

export const CLEARING_DEGREE_LEVEL_LABELS: Readonly<DegreeLevelLabel[]> = [
	'Clearing',
	'Undergraduate',
	'Postgraduate',
];

export const UNDERGRADUATE_DEGREE_LEVEL_LABELS: Readonly<DegreeLevelLabel[]> = [
	'Undergraduate',
	"Bachelor's",
	'HND',
	'HNC',
	'Foundation',
	'Access to Higher Education',
	'Undergraduate Certificates & Diplomas',
];

export const POSTGRADUATE_DEGREE_LEVEL_LABELS: Readonly<DegreeLevelLabel[]> = [
	'Postgraduate',
	"Master's",
	'PGCE courses',
	'PhD',
	'Postgraduate Diploma',
	'Postgraduate Certificate',
	'Postgraduate Certificates & Diplomas',
];

export const DEGREE_ROUTES = [
	'undergraduate',
	'foundation',
	'undergraduate-certificate-diplomas',
	'hnd',
	'hnc',
	'access-to-higher-education',
	'postgraduate',
	'masters',
	'phd',
	'postgraduate-certificate-diplomas',
	'pgce',
	'postgraduate-certificate',
	'postgraduate-diploma',
];

export const LOCATION_ROUTES = [
	'east-midlands',
	'east-of-england',
	'london',
	'north-east-england',
	'north-west-england',
	'northern-ireland',
	'scotland',
	'south-east-england',
	'south-west-england',
	'wales',
	'west-midlands',
	'yorkshire-and-the-humber',
];

export const COURSE_SEARCH_FILTER_TOOLTIPS = [
	{
		filterLabel: 'All undergraduate courses',
		tooltip:
			'Includes all undergraduate courses including available certificates and diplomas',
	},
	{
		filterLabel: 'Undergraduate certificate & diplomas',
		tooltip:
			'Only includes all certificates and diplomas at the  undergraduate level',
	},
	{
		filterLabel: 'All postgraduate courses',
		tooltip:
			'Includes all postgraduate courses including available certificates and diplomas',
	},
	{
		filterLabel: 'Postgraduate certificate & diplomas',
		tooltip: 'Only includes all certificates and diplomas at the postgraduate level',
	},
];

export const LOCATIONS: RadioSelect[] = [
	{
		name: 'All locations',
		link: '',
		count: 0,
		checked: false,
	},
	{
		name: 'East Midlands',
		link: 'east-midlands',
		count: 0,
		checked: false,
	},
	{
		name: 'East of England',
		link: 'east-of-england',
		count: 0,
		checked: false,
	},
	{
		name: 'London',
		link: 'london',
		count: 0,
		checked: false,
	},
	{
		name: 'North East England',
		link: 'north-east-england',
		count: 0,
		checked: false,
	},
	{
		name: 'North West England',
		link: 'north-west-england',
		count: 0,
		checked: false,
	},
	{
		name: 'Northern Ireland',
		link: 'northern-ireland',
		count: 0,
		checked: false,
	},
	{
		name: 'Scotland',
		link: 'scotland',
		count: 0,
		checked: false,
	},
	{
		name: 'South East England',
		link: 'south-east-england',
		count: 0,
		checked: false,
	},
	{
		name: 'South West England',
		link: 'south-west-england',
		count: 0,
		checked: false,
	},
	{
		name: 'Wales',
		link: 'wales',
		count: 0,
		checked: false,
	},
	{
		name: 'West Midlands',
		link: 'west-midlands',
		count: 0,
		checked: false,
	},
	{
		name: 'Yorkshire & the Humber',
		link: 'yorkshire-and-the-humber',
		count: 0,
		checked: false,
	},
];

export const UNDERGRADUATE_DEGREE_LEVELS: RadioSelect[] = [
	{
		name: 'All undergraduate courses',
		link: 'undergraduate',
		count: 0,
		checked: false,
	},
	{
		name: "Bachelor's",
		link: 'degrees',
		count: 0,
		checked: false,
	},
	{
		name: 'Foundation',
		link: 'foundation',
		count: 0,
		checked: false,
	},
	{
		name: 'Undergraduate certificate & diplomas',
		link: 'undergraduate-certificate-diplomas',
		count: 0,
		checked: false,
	},
	{
		name: 'Higher National Diploma (HND)',
		link: 'hnd',
		count: 0,
		checked: false,
	},
	{
		name: 'Higher National Certificate (HNC)',
		link: 'hnc',
		count: 0,
		checked: false,
	},
	{
		name: 'Access to Higher Education',
		link: 'access-to-higher-education',
		count: 0,
		checked: false,
	},
];

export const POSTGRADUATE_DEGREE_LEVELS: RadioSelect[] = [
	{
		name: 'All postgraduate courses',
		link: 'postgraduate',
		count: 0,
		checked: false,
	},
	{
		name: "Master's",
		link: 'masters',
		count: 0,
		checked: false,
	},
	{
		name: 'PhDs',
		link: 'phd',
		count: 0,
		checked: false,
	},
	{
		name: 'Postgraduate certificate & diplomas',
		link: 'postgraduate-certificate-diplomas',
		count: 0,
		checked: false,
	},
	{
		name: 'PGCE',
		link: 'pgce',
		count: 0,
		checked: false,
	},
	{
		name: 'Postgraduate Certificate (PGCert)',
		link: 'postgraduate-certificate',
		count: 0,
		checked: false,
	},
	{
		name: 'Postgraduate Diploma (PGDip)',
		link: 'postgraduate-diploma',
		count: 0,
		checked: false,
	},
];

export const STUDY_OPTIONS: RadioSelect[] = [
	{
		name: 'Full-time',
		link: 'mode=full-time',
		count: 0,
		checked: false,
	},
	{
		name: 'Part-time',
		link: 'mode=part-time',
		count: 0,
		checked: false,
	},
	{
		name: 'Sandwich',
		link: 'mode=sandwich',
		count: 0,
		checked: false,
	},
	{
		name: 'Distance/Online',
		link: 'mode=distance',
		count: 0,
		checked: false,
	},
];
